export default __webpack_public_path__ + "static/media/Alissem.e9da47ed.png";